export default __webpack_public_path__ + "static/media/people1.97f257e2.png";